module.exports = __webpack_public_path__ + "static/media/kalam-light-webfont.0fb2ffc7.woff";